<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">domain</v-icon>
      Locations
      <template slot="buttons">
        <router-link :to="{ name: 'hrClientBusinesses' }">
          Back to Locations
        </router-link>
      </template>
    </HeaderBar>

    <div v-if="apiCallPending">
      <v-progress-linear indeterminate></v-progress-linear>
    </div>

    <div v-else>
      <v-layout class="my-2">
        <v-flex shrink class="mr-2">
          <h1 v-if="!editingName">{{ detailedClientBusiness.name }}</h1>
          <h1 v-if="editingName">
            <ApiField
              storeAction="clientBusinesses/update"
              paramName="client_business"
              :object="detailedClientBusiness"
              fieldName="name"
              :storeFieldValue="detailedClientBusiness.name"
              label="Name"
            >
            </ApiField>
          </h1>
        </v-flex>
        <v-flex shrink>
          <v-icon @click="editingName = true" v-if="!editingName">
            create
          </v-icon>
          <v-icon @click="editingName = false" v-if="editingName">
            close
          </v-icon>
        </v-flex>
      </v-layout>

      <v-layout row class="my-2">
        <v-flex>
          <v-tabs color="primary" dark slider-color="white" show-arrows>
            <v-tabs-slider></v-tabs-slider>
            <v-tab ripple>
              Locations
            </v-tab>
            <v-tab ripple>
              Teams
            </v-tab>
            <v-tab ripple>
              Shifts
            </v-tab>
            <v-tab ripple>
              Evaluations
            </v-tab>

            <v-tab-item class="pa-2 white">
              <v-card>
                <v-card-text>
                  <ClientBusinessLocations
                    :clientBusiness="detailedClientBusiness"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item class="pa-2 white">
              <v-card>
                <v-card-text>
                  <ClientBusinessTeams
                    :locations="detailedClientBusiness.locations"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item class="pa-2 white">
              <v-card>
                <v-card-text>
                  <ClientBusinessShifts
                    :clientBusiness="detailedClientBusiness"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item class="pa-2 white">
              <v-card>
                <v-card-text>
                  <ClientBusinessReviews
                    :clientBusiness="detailedClientBusiness"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import collectionsApi from '@/api/collections';
  import ApiField from '@/components/base/api-field.vue';
  import HeaderBar from '@/components/base/header-bar.vue';
  import ClientBusinessAdmin from '@/components/hr/client-business-admin.vue';
  import ClientBusinessLocations from '@/components/hr/client-business-locations.vue';
  import ClientBusinessTeams from '@/components/hr/client-business-teams.vue';
  import ClientBusinessUsers from '@/components/hr/client-business-users.vue';
  import ClientBusinessShifts from '@/components/hr/client-business-shifts.vue';
  import ClientBusinessReviews from '@/components/hr/client-business-reviews.vue';

  export default {
    components: {
      ApiField,
      HeaderBar,
      ClientBusinessAdmin,
      ClientBusinessLocations,
      ClientBusinessUsers,
      ClientBusinessTeams,
      ClientBusinessShifts,
      ClientBusinessReviews,
    },
    computed: {
      ...mapState('userAuth', ['user']),
      ...mapState('clientBusinesses', ['detailedClientBusiness']),
      exampleComputed: function() {
        return this.example;
      },
    },
    created() {
      this.setUp();
    },
    watch: {},
    data: function() {
      return {
        apiCallPending: false,
        editingName: false,
      };
    },
    methods: {
      setUp() {
        this.apiCallPending = true;
        this.$store
          .dispatch(
            'clientBusinesses/getClientBusiness',
            this.$route.params.clientBusinessId,
          )
          .finally(r => {
            this.apiCallPending = false;
          });
      },
    },
  };
</script>

<style scoped></style>
